import { Box, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	color: string;
	inset: number;
};

export const UnreadDot: FC<Props> = ({ color, inset }) => {
	const { notificationCenter } = useTheme();
	const { size } = notificationCenter.unreadDot;

	return (
		<Box
			aria-hidden
			position="absolute"
			left={inset}
			top="50%"
			width={size}
			height={size}
			borderRadius="50%"
			bgcolor={color}
			sx={{ transform: "translateY(-50%)" }}
		/>
	);
};
